import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Landing from "@/pages/Landing";

function App() {
  return (
    // reducedMotion="user" makes every motion component drop transform/layout
    // animation when the OS asks for it, while keeping opacity fades.
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
